// extracted by mini-css-extract-plugin
export var product_link = "ModalDownloadApp-module--product_link--t8usz";
export var product_link_arrow = "ModalDownloadApp-module--product_link_arrow--pdAzL";
export var product_link_logo = "ModalDownloadApp-module--product_link_logo--MheBY";